import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Datenschutz } from './pages/Datenschutz';
import { Home } from './pages/Home';
import { Impressum } from './pages/Impressum';
import { Kontakt } from './pages/Kontakt';
import { KontaktErfolg } from './pages/KontaktErfolg';
import { Leistungen } from './pages/Leistungen';
import { ServiceDetail } from './pages/ServiceDetail';
import { NotFound } from './pages/NotFound';
import { Referenzen } from './pages/Referenzen';
import { Unternehmen } from './pages/Unternehmen';

const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Home />} />
      <Route path="/leistungen" element={<Leistungen />} />
      <Route path="/leistungen/:serviceId" element={<ServiceDetail />} />
      <Route path="/unternehmen" element={<Unternehmen />} />
      <Route path="/referenzen" element={<Referenzen />} />
      <Route path="/downloads" element={<Navigate to="/" replace />} />
      <Route path="/kontakt" element={<Kontakt />} />
      <Route path="/kontakt-erfolgreich" element={<KontaktErfolg />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default App;
